import React, { useState, useRef } from 'react';
import './HabitItem.css';
import { celebrateAchievement } from '../utils/feedback';
import IngredientEducation from './IngredientEducation';

const HabitItem = ({ habit, onComplete, currentDate }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [showIngredientInfo, setShowIngredientInfo] = useState(false);
  const habitItemRef = useRef(null);

  const handleComplete = () => {
    if (habit.isCompleted) return;

    setIsAnimating(true);

    // Trigger celebration effects
    if (habitItemRef.current) {
      celebrateAchievement(habitItemRef.current, 'completion');
    }

    setTimeout(() => {
      onComplete();
      setIsAnimating(false);
    }, 300);
  };

  const getHabitTypeLabel = () => {
    if (habit.frequency === 'weekly') {
      return `Weekly • ${habit.timesPerWeek || 1}x per week`;
    } else if (habit.frequency === 'monthly') {
      return 'Monthly Treatment';
    }
    return 'Daily';
  };

  const isSpecialTreatment = habit.frequency !== 'daily';
  const isPriority = habit.priority === 'high';

  return (
    <div
      ref={habitItemRef}
      className={`habit-item ${habit.isCompleted ? 'completed' : ''} ${isSpecialTreatment ? 'special-treatment' : ''} ${isPriority ? 'priority' : ''} ${isAnimating ? 'animating' : ''}`}
    >
      <div className="habit-content">
        <button 
          className="habit-checkbox"
          onClick={handleComplete}
          disabled={habit.isCompleted}
          aria-label={`${habit.isCompleted ? 'Completed' : 'Complete'} ${habit.name}`}
        >
          <div className="checkbox-inner">
            {habit.isCompleted && <span className="checkmark">✓</span>}
          </div>
        </button>

        <div className="habit-info">
          <div className="habit-header">
            <span className="habit-icon">{habit.icon}</span>
            <h4 className="habit-name">{habit.name}</h4>
            {isPriority && <span className="priority-badge">Priority</span>}
          </div>
          
          <p className="habit-description">{habit.description}</p>
          
          <div className="habit-meta">
            <span className="habit-frequency">{getHabitTypeLabel()}</span>
            <span className="habit-category">{habit.category}</span>
            {habit.concernBased && (
              <span className="concern-badge">
                For {habit.concern.replace('-', ' ')}
              </span>
            )}
          </div>

          {habit.ingredient && (
            <button
              className="ingredient-info-button"
              onClick={() => setShowIngredientInfo(true)}
              title={`Learn about ${habit.ingredient}`}
            >
              ℹ️ Learn about ingredients
            </button>
          )}
        </div>
      </div>

      {isSpecialTreatment && (
        <div className="special-treatment-indicator">
          <span className="special-icon">⭐</span>
          <span className="special-text">Special Treatment</span>
        </div>
      )}

      {habit.isCompleted && (
        <div className="completion-feedback">
          <span className="completion-icon">✨</span>
        </div>
      )}

      <IngredientEducation
        isOpen={showIngredientInfo}
        onClose={() => setShowIngredientInfo(false)}
        ingredient={habit.ingredient}
      />
    </div>
  );
};

export default HabitItem;
